import { func, string } from "prop-types"
import { useCallback } from "react"
import { useDropzone } from "react-dropzone"
import PreviewThumbnail from "./PreviewThumbnail"
import PreviewHelper from "./PreviewHelper"
import { Uploader, UploaderBox } from "./styled"

const ACCEPT = "image/jpeg, image/png"

const LogoUploader = ({ onChange, preview }) => {
  const onRemove = useCallback((e) => {
    e.stopPropagation()
    onChange(null)
  }, [])
  const onDrop = useCallback((acceptedFiles) => {
    const file = acceptedFiles[0]
    const reader = new FileReader()

    reader.onabort = () => console.log("file reading was aborted")
    reader.onerror = () => console.log("file reading has failed")
    reader.onload = () => {
      const preview = reader.result
      onChange(preview)
    }

    reader.readAsDataURL(file)
  }, [])
  const { getRootProps, getInputProps } = useDropzone({
    onDrop,
    accept: ACCEPT,
  })

  return (
    <Uploader>
      <UploaderBox {...getRootProps()}>
        <input {...getInputProps()} name="uploader" />
        {preview ? (
          <PreviewThumbnail onRemove={onRemove} preview={preview} />
        ) : (
          <PreviewHelper />
        )}
      </UploaderBox>
    </Uploader>
  )
}

LogoUploader.propTypes = {
  onChange: func,
  preview: string,
}

export default LogoUploader
